import React from 'react';
import { get, find } from 'lodash';

// local dependencies
import { memberServicesEscalations as MemberServicesEscalationsView } from 'ui/views/widgets/memberServicesEscalations';
import { MemberServicesEscalationsService } from 'services/memberServicesEscalations';
import * as pageLevelPreloader from 'modules/page-level-preloader';
import * as errorOverlay from 'utils/errorOverlay';
import * as successOverlay from 'utils/successOverlay';
import { GLOBAL_LABELS } from 'constants/common';
import { getLabel } from 'utils/getLabel';
import { SERVICE_RESPONSE_STATUS } from 'constants/common';

/**
 * @type {class}
 * @desc A React container/smart component to render a React presentational/dumb component (view).
 * @example
 * import { MemberServicesEscalations } from 'ui/containers/MemberServicesEscalations';
 *
 * // render
 * <MemberServicesEscalations propName='propValue'/>
 */
export class MemberServicesEscalations extends React.Component {
    
    /**
     * @param {object} props - props
     */
    constructor( props ) {
        super( props );

        this.memberServicesEscalationsService = new MemberServicesEscalationsService();

        this.onFormSubmit = this.onFormSubmit.bind( this );
    }

    /**
     * @desc executes when user submits form
     */
    async onFormSubmit( formData ) {
        log.debug( 'MemberServicesEscalations.onFormSubmit()' );

        const context = get( this.props, 'context', {} );
        const successAction = find( this.props.actions, { name: 'submit' } );

        // close overlay
        this.props.onCancelClick();

        // show page preloader
        pageLevelPreloader.show();

        const { status } = await this.memberServicesEscalationsService.submitFormData( {
            url: successAction.url,
            data: {
                context,
                data: formData
            }
        } );

        // hide page preloader
        pageLevelPreloader.hide();

        if( SERVICE_RESPONSE_STATUS.SUCCESS === status ) {
            successOverlay.open( { message: getLabel( GLOBAL_LABELS.DISPLAY_TEXT_DONE_SUCCESSFULLY ), } );

        } else {
            errorOverlay.open();
        }
    }

    /**
     * @desc Render a React view component
     */
    render() {
        return (
            <MemberServicesEscalationsView
                { ...this.props }
                onFormSubmit={ this.onFormSubmit }
            />
        );
    }
}

// set display name
MemberServicesEscalations.displayName = 'MemberServicesEscalations';

// set default props
MemberServicesEscalations.defaultProps = {};

// prop types
MemberServicesEscalations.propTypes = {};
